const tabCache = {
    dashboard: {
      data: null,
      totals: null,
      firstLoad: true,
    },
  };
  
  export default tabCache;
  